import React from 'react';
import { Link } from 'react-router-dom';

const TermsConditions = () => {
  return (
    <div className="legal-page">
      <div className="container">
        <div className="legal-header">
          <Link to="/" className="back-to-home">
            ← Volver al inicio
          </Link>
          <h1 className="legal-title">📋 Términos y Condiciones</h1>
          <p className="legal-subtitle">GesOps LLC - Última actualización: Octubre 2025</p>
        </div>

        <div className="legal-content">
          <section className="legal-section">
            <h2>1. Aceptación de los Términos</h2>
            <p>
              Al acceder y utilizar el sitio web de GesOps LLC (www.gesops.com), usted acepta estar sujeto a estos 
              Términos y Condiciones. Si no está de acuerdo con alguno de estos términos, no utilice nuestros servicios.
            </p>
          </section>

          <section className="legal-section">
            <h2>2. Descripción del Servicio</h2>
            <p>
              GesOps LLC opera como un <strong>directorio digital de abogados verificados</strong>. Nuestros servicios incluyen:
            </p>
            <ul>
              <li>Directorio nacional de abogados por estado y especialidad</li>
              <li>Verificación de perfiles profesionales</li>
              <li>Facilitación de contacto directo entre usuarios y abogados</li>
              <li>Servicios de membresía para abogados (Estándar y Premium)</li>
            </ul>
            <p>
              <strong>IMPORTANTE:</strong> GesOps LLC NO proporciona asesoría legal, NO practica derecho y 
              NO sustituye la representación legal profesional.
            </p>
          </section>

          <section className="legal-section">
            <h2>3. Elegibilidad y Registro</h2>
            <p>Para utilizar nuestros servicios, usted debe:</p>
            <ul>
              <li>Ser mayor de 18 años o tener autorización parental</li>
              <li>Proporcionar información veraz y actualizada</li>
              <li>Mantener la confidencialidad de sus credenciales de acceso</li>
              <li>Cumplir con todas las leyes aplicables</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>4. Uso Aceptable</h2>
            <p>Al utilizar nuestros servicios, usted se compromete a:</p>
            <ul>
              <li>Utilizar el directorio únicamente para fines legítimos</li>
              <li>No interferir con el funcionamiento del sitio web</li>
              <li>No intentar acceder a áreas restringidas</li>
              <li>No utilizar información de abogados para spam o solicitudes masivas</li>
              <li>Respetar los derechos de propiedad intelectual</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>5. Servicios para Abogados</h2>
            <h3>5.1 Membresías</h3>
            <p>Ofrecemos dos tipos de membresía:</p>
            <ul>
              <li><strong>Plan Estándar ($80/mes):</strong> Perfil básico en el directorio nacional</li>
              <li><strong>Plan Premium ($250/mes):</strong> Perfil completo con beneficios adicionales</li>
            </ul>
            
            <h3>5.2 Verificación de Perfiles</h3>
            <p>
              Todos los abogados en nuestro directorio han sido verificados. Sin embargo, GesOps LLC no garantiza 
              la calidad de los servicios legales proporcionados por los abogados listados.
            </p>
          </section>

          <section className="legal-section">
            <h2>6. Limitación de Responsabilidad</h2>
            <p>
              <strong>GesOps LLC actúa únicamente como intermediario tecnológico</strong> y no será responsable por:
            </p>
            <ul>
              <li>La calidad, exactitud o resultado de los servicios legales</li>
              <li>Disputas entre usuarios y abogados</li>
              <li>Pérdidas o daños derivados del uso del directorio</li>
              <li>Interrupciones temporales del servicio</li>
              <li>Decisiones tomadas basándose en información del directorio</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>7. Propiedad Intelectual</h2>
            <p>
              Todo el contenido del sitio web de GesOps LLC, incluyendo diseño, logotipos, textos e imágenes, 
              está protegido por derechos de autor y otras leyes de propiedad intelectual.
            </p>
          </section>

          <section className="legal-section">
            <h2>8. Privacidad y Protección de Datos</h2>
            <p>
              El manejo de su información personal se rige por nuestra Política de Privacidad, 
              que forma parte integral de estos Términos y Condiciones.
            </p>
          </section>

          <section className="legal-section">
            <h2>9. Modificaciones</h2>
            <p>
              GesOps LLC se reserva el derecho de modificar estos Términos y Condiciones en cualquier momento. 
              Los cambios serán efectivos inmediatamente después de su publicación en el sitio web.
            </p>
          </section>

          <section className="legal-section">
            <h2>10. Terminación</h2>
            <p>
              Podemos suspender o terminar su acceso a nuestros servicios en caso de violación de estos términos 
              o por cualquier razón, con o sin previo aviso.
            </p>
          </section>

          <section className="legal-section">
            <h2>11. Ley Aplicable y Jurisdicción</h2>
            <p>
              Estos Términos y Condiciones se rigen por las leyes del Estado de Florida, Estados Unidos. 
              Cualquier disputa será resuelta en los tribunales competentes de Florida.
            </p>
          </section>

          <section className="legal-section">
            <h2>12. Contacto</h2>
            <p>
              Para preguntas sobre estos Términos y Condiciones, contáctenos:
            </p>
            <div className="legal-contact-info">
              <p><strong>GesOps LLC</strong></p>
              <p>📧 Email: info@gesops.com</p>
              <p>🏢 Dirección: 1420 Celebration Blvd, Suite 101, Celebration, FL 34747, Estados Unidos</p>
              <p>💬 WhatsApp Business: [Disponible en el sitio web]</p>
            </div>
          </section>

          <div className="legal-disclaimer">
            <p>
              <strong>Recordatorio:</strong> GesOps LLC es un directorio tecnológico y no proporciona servicios legales. 
              Siempre consulte con un abogado calificado para asesoría legal específica.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsConditions;
